import { canv } from "@/canv/global";
import { t } from "@/i18n";
import style from "./updateTariff.module.css";

// TODO: в 15 релизе подъедет React и нужно будет переписать это на него
export class UpdateTariffWindow {
    getLocalStorage(boardUID: string) {
        const res = localStorage.getItem(getLocalStorageName(boardUID));

        return res === "true";
    }

    setLocalStorage(boardUID: string) {
        localStorage.setItem(getLocalStorageName(boardUID), "true");
    }

    show(boardUID: string, onlyRead?: boolean) {
        if (
            !this.getLocalStorage(boardUID) &&
            onlyRead &&
            canv.getInitDataProp("isTeamOwner") === true
        ) {
            this.template();

            if (!this.wrapper) {
                throw new Error("Не удалось открыть окно тарифа");
            }

            this.addListeners();
            this.setLocalStorage(boardUID);

            document.body.appendChild(this.wrapper);
        }
    }

    hide = () => {
        if (!this.wrapper) {
            throw new Error("Не удалось закрыть окно тарифа");
        }

        this.removeListeners();
        document.body.removeChild(this.wrapper);
    };

    updateTariff = () => {
        const teamId = canv.getInitDataProp("teamId");
        if (!teamId) return;

        window.open(`${canv.host}/dashboard?need_tariff_payment=true&teamId=${teamId}`, "_blank");
    };

    removeListeners() {
        this.closeButton?.removeEventListener("mouseup", this.hide);
        this.updateTariffButton?.removeEventListener("mouseup", this.updateTariff);
    }

    addListeners() {
        this.closeButton?.addEventListener("mouseup", this.hide);
        this.updateTariffButton?.addEventListener("mouseup", this.updateTariff);
    }

    template() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add(style.updateTariffWindowWrapper);

        const modal = document.createElement("div");
        modal.classList.add(style.updateTariffWindow);

        this.closeButton = document.createElement("button");
        this.closeButton.classList.add(style.closeButton, "button", "button--close");
        this.closeButton.type = "button";
        // TODO: при переписывании на React эта иконка будет заменена на общую closeIcon
        this.closeButton.innerHTML = `
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M1 1L13 13" stroke="#2C2D32" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;

        const contentWrapper = document.createElement("div");
        contentWrapper.classList.add(style.contentWrapper);

        const imageWrapper = document.createElement("div");
        imageWrapper.classList.add(style.lockImageWrapper);

        const image = document.createElement("img");
        image.classList.add(style.lockImage);
        image.src = `${canv.host}/api/v2/static/media/lockImage.png`;

        const title = document.createElement("div");
        title.classList.add(style.title);
        title.textContent = t("updateTariff.title");

        const description = document.createElement("div");
        description.classList.add(style.description);
        description.innerHTML = `
            <p>${t("updateTariff.description1")}</p>
            <p>${t("updateTariff.description2")}</p>
            <p>${t("updateTariff.description3")}</p>
        `;

        this.updateTariffButton = document.createElement("button");
        this.updateTariffButton.classList.add(style.updateTariffButton);
        this.updateTariffButton.textContent = t("updateTariff.action");

        imageWrapper.appendChild(image);

        contentWrapper.appendChild(imageWrapper);
        contentWrapper.appendChild(title);
        contentWrapper.appendChild(description);

        modal.appendChild(this.closeButton);
        modal.appendChild(contentWrapper);
        modal.appendChild(this.updateTariffButton);

        this.wrapper.appendChild(modal);
    }

    wrapper: HTMLDivElement | null = null;
    closeButton: HTMLButtonElement | null = null;
    updateTariffButton: HTMLButtonElement | null = null;
}

function getLocalStorageName(boardUID: string) {
    return `showedToUpdateTariffWindowFor-${boardUID}`;
}
